import { getToday } from '@shared/services/dateService';
import { create } from 'zustand';

export const useIsUserActingAsATMStore = create(set => ({
  isUserActingAsATM: null,
  toggleIsUserActingAsATM: () => set(state => ({ isUserActingAsATM: !state.isUserActingAsATM })),
  setIsUserActingAsATM: isUserActingAsATM => set(() => ({ isUserActingAsATM }))
}));

export const useSelectedDateStore = create(set => ({
  selectedDate: null,
  previousSelectedDate: getToday(),

  setSelectedDate: selectedDate => set(() => ({ selectedDate })),
  setPreviousSelectedDate: previousSelectedDate => set(() => ({ previousSelectedDate })),
  resetSelectedDate: () =>
    set(({ selectedDate }) => ({
      selectedDate: null,
      previousSelectedDate: selectedDate
    }))
}));
